<template>
  <callCenterList></callCenterList>
</template>

<script>
// Component
import callCenterList from "@/views/callCenter/list/Index.vue";
export default {
  components: {
    callCenterList,
  },
};
</script>

<style>
#call-center-list {
  margin-top: 100px;
}
</style>
